import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'excel-viewer',
  template: `
    <div class="sheet-tabs">
      <button *ngFor="let sheet of sheets; let i = index"
              (click)="activeSheetIndex = i"
              [class.active]="i === activeSheetIndex">
        {{ sheet.name }}
      </button>
    </div>

    <div class="sheet-content">
      <table>
        <tr *ngFor="let row of activeSheet?.rows; let rowIndex = index">
          <td *ngFor="let cell of row" [class.header]="rowIndex === 0">{{ cell }}</td>
        </tr>
      </table>
    </div>
  `,
  styles: [`
    .sheet-tabs {
      display: flex;
      gap: 10px;
      margin-bottom: 10px;
    }
    .sheet-tabs button.active {
      font-weight: bold;
      border-bottom: 2px solid #00796b;
    }
    table {
      width: 100%;
      border-collapse: collapse;
    }
    td {
      border: 1px solid #ddd;
      padding: 5px;
    }
    td.header {
      font-weight: bold;
      background-color: #f1f1f1;
    }
  `],
  imports: [CommonModule]
})
export class ExcelViewerComponent {
  @Input() sheets: { name: string; rows: any[][] }[] = [];
  activeSheetIndex = 0;
  get activeSheet() {
    
    return this.sheets[this.activeSheetIndex];
  }
}
